import { render, staticRenderFns } from "./CommonIconTop.vue?vue&type=template&id=ed45ffce&lang=pug&"
import script from "./CommonIconTop.vue?vue&type=script&lang=ts&"
export * from "./CommonIconTop.vue?vue&type=script&lang=ts&"
import style0 from "./CommonIconTop.vue?vue&type=style&index=0&id=ed45ffce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports